import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatusPageService } from '../../../services/status-page.service';
import { NbIconConfig, NbToastrService } from '@nebular/theme';
import { Terminal, TerminalAction } from 'src/app/@core/domain/interfaces/terminal.interface';
import { TerminalsApiService } from 'src/app/@core/api/terminals-api.service';
import { LogService } from 'src/app/@core';
import { TranslateService } from '@ngx-translate/core';
import { TrackingService } from 'src/app/@shared/services/tracking.service';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
})
export class ActionComponent implements OnInit {
  @Input() terminal!: Terminal;
  @Input() action?: TerminalAction;
  @Input() disableToggleClick = false;

  @Output()
  preventToggleClick = new EventEmitter<boolean>();

  @Output()
  actionCompleted = new EventEmitter<boolean>();

  index = 0;
  awaitTerminalActionComplete = false;
  currentStatusToggle = false;
  checked = false;
  actionInProgress = false;

  toastrSuccessMessage = '';
  toastrErrorMessage = '';

  constructor(
    private terminalsApiService: TerminalsApiService,
    private statusPageService: StatusPageService,
    private toastrService: NbToastrService,
    private translate: TranslateService,
    private logger: LogService,
    private trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.statusPageService.triggerRefreshTerminalSummary(false);
    if (!this.action) {
      this.currentStatusToggle = true;
      this.checked = false;
    } else {
      this.checked = false;
    }
    this.translate.get('NOTIFICATIONS.TERMINAL_ACTION.SUCCESS').subscribe((res: string) => {
      this.toastrSuccessMessage = res;
    });
    this.translate.get('NOTIFICATIONS.TERMINAL_ACTION.ERROR').subscribe((res: string) => {
      this.toastrErrorMessage = res;
    });
  }

  setAction(id: number, actionType: number): void {
    this.actionInProgress = true;
    if (this.disableToggleClick) {
      this.checked = false;
      return;
    }
    this.preventToggleClick.emit(true);
    this.awaitTerminalActionComplete = true;
    this.terminalsApiService.sendTerminalAction(id, { type: actionType }).subscribe((result) => {
      if (result.success) {
        setTimeout(() => {
          // TODO decouple API from components, introduce store and state
          this.logger.info(
            'Terminal action with type ' + actionType + ' on terminal ' + id + ' successful'
          );
          this.awaitTerminalActionComplete = false;
          const iconConfig: NbIconConfig = { icon: 'checkmark-outline', pack: 'eva' };
          this.showToast(result.message, this.toastrSuccessMessage, {
            status: 'success',
            hasIcon: true,
            icon: iconConfig,
            duration: 10000,
            destroyByClick: false,
          });
          this.actionCompleted.emit(true);
          this.statusPageService.triggerRefreshTerminalSummary(true);
          this.checked = true;
          this.actionInProgress = false;
          this.trackingService.eventEmitter('terminalAction', 'action', 'success', '', 0);
        }, 3000);
      } else {
        this.logger.info('Terminal action with type ' + actionType + ' failed');
        this.awaitTerminalActionComplete = false;
        this.currentStatusToggle = false;
        this.checked = false;
        const iconConfig: NbIconConfig = { icon: 'alert-triangle-outline', pack: 'eva' };
        this.showToast(result.message, this.toastrErrorMessage, {
          status: 'danger',
          hasIcon: true,
          icon: iconConfig,
          duration: 10000,
          destroyByClick: false,
        });
        this.statusPageService.triggerRefreshTerminalSummary(true);
        this.actionInProgress = false;
        this.trackingService.eventEmitter('terminalAction', 'action', 'failed', '', 0);
      }
    });
  }

  showToast(message: string, title: string, config: any) {
    this.index += 1;
    this.toastrService.show(message, title, config);
  }
}
